import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import capitalize from "lodash/capitalize";

import Label from "components/library/Label";
import DatePicker from "components/library/DatePicker";
import TimePicker from "components/library/TimePicker";
import Button from "components/library/Button";
import validateFutureDate from "editor/utils/validateFutureDate";
import isDateNotInPast from "editor/utils/isDateNotInPast";

import styles from "./DateTimePicker.css";

class DateTimePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
        ? this.props.value
        : moment(new Date(), moment.ISO_8601)
            .add(6, "hours")
            .startOf("minute"),
    };
    this.handleChange = this._handleChange.bind(this);
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleClearForm = this._handleClearForm.bind(this);
  }

  _handleChange(value) {
    this.setState({ value });
  }

  _handleSubmit() {
    const error = validateFutureDate(this.state.value);
    if (error) {
      this.setState({ error });
    } else {
      this.props.onSubmit(this.state.value); // Change Moment.js object back to string
    }
  }

  _handleClearForm() {
    this.props.onSubmit(null);
  }

  render() {
    return (
      <div className={styles.featuredDateForm}>
        <Label htmlFor="datetime">{this.props.formText}</Label>
        <div className={styles.datetime}>
          <DatePicker
            className={styles.input}
            value={this.state.value}
            error={this.state.error}
            onChange={this.handleChange}
            isValidDate={isDateNotInPast}
          />
          <TimePicker
            className={styles.input}
            value={this.state.value}
            error={this.state.error}
            onChange={this.handleChange}
            isValidDate={isDateNotInPast}
          />
        </div>
        <div className={styles.datetimeButtons}>
          <Button
            className={styles.button}
            onClick={this.handleSubmit}
            type="secondary"
          >
            {capitalize(this.props.buttonText)}
          </Button>
          <Button
            className={styles.button}
            onClick={this.props.onCancel}
            type="tertiary"
          >
            Cancel
          </Button>
          {this.props.value && (
            <Button
              className={`${styles.button} ${styles.removeButton}`}
              onClick={this.handleClearForm}
              type="tertiary"
              destructive
            >
              Remove {this.props.buttonText}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

DateTimePicker.propTypes = {
  value: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  formText: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
};

export default DateTimePicker;
